import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";

function App() {
  return (
    <div className="App ocean-bg grain">
      <Dashboard />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
